<template>
    <v-layout row wrap align-center>
        <v-flex xs6 lg6>
            <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                max-width="290px"
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                        class="mb-0"
                        :value="formattedStartDate"
                        :label="$t('label.start_date')"
                        readonly
                        persistent-hint
                        prepend-icon="event"
                        v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                    :locale="$i18n.locale"
                    :max="IOSEnd"
                    :value="IOSStart"
                    @input="updateStartDate"
                    no-title
                ></v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex xs6 lg6>
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                max-width="290px"
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                        class="mb-0"
                        :value="formattedEndtDate"
                        :label="$t('label.end_date')"
                        readonly
                        persistent-hint
                        prepend-icon="event"
                        v-on="on"
                    ></v-text-field>
                </template>

                <v-layout>
                    <v-date-picker
                        :locale="$i18n.locale"
                        :value="IOSEnd"
                        :max="today"
                        :min="IOSStart"
                        @input="updateEndDate"
                        no-title
                    ></v-date-picker>
                </v-layout>
            </v-menu>
        </v-flex>
        <v-flex>
            <v-radio-group :value="range" @change="changeRange" row class="mb-0">
                <v-radio :label="$t('label.day')" value="day"></v-radio>
                <v-radio :label="$t('label.week')" value="week"></v-radio>
                <v-radio :label="$t('label.month')" value="month"></v-radio>
            </v-radio-group>
        </v-flex>
        <v-flex class="text-xs-right">
            <slot name="loader"></slot>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    data() {
        return {
            menu: false,
            menu2: false,
        }
    },
    props: {
        range: { type: String },
        start: { type: Date | null },
        end: { type: Date | null },
    },
    computed: {
        ...mapGetters({
            fullLocale: "user/fullLocale",
        }),
        formattedStartDate() {
            return this.start ? this.start.toLocaleDateString(this.fullLocale) : ""
        },
        formattedEndtDate() {
            return this.end ? this.end.toLocaleDateString(this.fullLocale) : ""
        },
        min() {
            console.log("aaaaa")
            if (!this.start) {
                return this.formatDate(new Date())
            }
            return this.IOSStart
        },
        today() {
            return this.formatDate(new Date())
        },
        IOSStart() {
            return this.formatDate(this.start)
        },
        IOSEnd() {
            return this.formatDate(this.end)
        },
    },

    methods: {
        changeRange(range) {
            this.$emit("update:range", range)
        },
        updateStartDate(date) {
            this.$emit("update:start", new Date(date))
            this.menu = false
        },
        updateEndDate(date) {
            this.$emit("update:end", new Date(date))
            this.menu2 = false
        },
        formatDate(date) {
            if (!date) {
                return null
            }
            return date.toISOString().substr(0, 10)
        },
    },
}
</script>
